
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BarChart3, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// Mock data for demonstration - in real implementation this would come from GA4 API
const mockAnalyticsData = {
  totalCalibrations: 1247,
  last7Days: [12, 8, 15, 22, 18, 25, 19] // Simple trend data
};

const AnalyticsCard = () => {
  const navigate = useNavigate();

  const MiniBarChart = ({ data }: { data: number[] }) => {
    const max = Math.max(...data);
    return (
      <div className="flex items-end gap-1 h-8">
        {data.map((value, index) => (
          <div
            key={index}
            className="bg-primary/60 min-w-[3px] rounded-sm"
            style={{
              height: `${(value / max) * 100}%`
            }}
          />
        ))}
      </div>
    );
  };

  return (
    <Card className="cursor-pointer hover:shadow-md transition-shadow" onClick={() => navigate('/admin/analytics')}>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2 text-lg">
            <BarChart3 className="h-5 w-5" />
            Calibration Analytics
          </CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </div>
        <CardDescription>Track calibration completions</CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-4">
          {/* Total Calibrations */}
          <div>
            <div className="text-2xl font-bold">{mockAnalyticsData.totalCalibrations.toLocaleString()}</div>
            <p className="text-xs text-muted-foreground">Total Calibrations</p>
          </div>

          {/* Mini Bar Chart */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <p className="text-xs text-muted-foreground">Last 7 days</p>
              <MiniBarChart data={mockAnalyticsData.last7Days} />
            </div>
          </div>

          {/* See All Link */}
          <Button 
            variant="outline" 
            size="sm" 
            className="w-full mt-3"
            onClick={(e) => {
              e.stopPropagation();
              navigate('/admin/analytics');
            }}
          >
            See All
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AnalyticsCard;
